<template>
  <client-only>
    <template #fallback>
      <app-button disabled size="lg" tag="span" />
    </template>

    <course-page-enrolment-registration-link-cta
      v-if="!session.public && !currentUserIsAlreadyRegistered"
      block
      :course="course"
      :session="session"
      size="lg"
    />

    <app-button
      v-else-if="currentUserIsAlreadyRegistered"
      block
      data-cy-enroled-cta
      disabled
      size="lg"
    >
      <span>💜</span>
      <span class="text-black">{{ $t("course.page.enroled_label") }}</span>
    </app-button>

    <course-program-download-cta
      v-else
      block
      :course="course"
      origin="course"
      :session="session"
      size="lg"
    />
  </client-only>
</template>

<script lang="ts" setup>
import type { CoursePageView } from "~/business-areas/course/course.model";
import type { CourseSessionView } from "~/business-areas/course-session/course-session.model";
import CoursePageEnrolmentRegistrationLinkCta from "~/pages/courses/[slug]/_includes/components/course-page-enrolment-registration-link-cta.vue";

const properties = defineProps<{
  course: CoursePageView;
  session: CourseSessionView;
}>();

const { isRegisteredToCourseSession } = useLearnerProfile();

const currentUserIsAlreadyRegistered = computed(() =>
  isRegisteredToCourseSession(properties.session.id),
);
</script>
